import { ProductCatalogAttributeSelectionType } from '@graphql/generated-base';
import type { CatalogProductListFilters } from '../Catalog.types';

export const filterSupportedAttributeList = (filters: CatalogProductListFilters) => {
  return filters.filter(filter => {
    const { filterSelectionType } = filter.attributeGroup;
    return (
      filterSelectionType === ProductCatalogAttributeSelectionType.stringListMulti ||
      filterSelectionType === ProductCatalogAttributeSelectionType.priceRange ||
      filterSelectionType === ProductCatalogAttributeSelectionType.priceBucket
    );
  });
};
